import { Component, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective , FormControl } from '@angular/forms';
import { FormHelper } from '@forms';
import { UserService } from '@user';
import { __i18n } from '@localisation';
import { RoutingInfoService } from '@routing';
import { HttpHelperService } from '@http';
import { MessagesService, MessageType } from '@ui-messages';
import { Router } from '@angular/router';
import { GlobalEventBus, ActionEvents } from '@event-bus';
import { StateService, States } from '@state';

@Component({
    selector: 'reset-password',
    templateUrl: './change.password.template.html',
    standalone: false
})
export class ChangePasswordComponent {
    constructor(
        private formBuilder: FormBuilder,
        private formHelper: FormHelper,
        private user: UserService,
        private routingInfos: RoutingInfoService,
        private httpHelper: HttpHelperService,
        private messageService: MessagesService,
        private router: Router,
        private changeDetection: ChangeDetectorRef,
        private eventBus: GlobalEventBus,
        private stateService: StateService
    ) {
        const formGroupConfig: any = {
            oldpassword: ['', Validators.compose([Validators.required])],
            password: ['', Validators.compose([Validators.required])],
            confirmPassword: ['', Validators.compose([Validators.required])]
        };

        this.changePasswordForm = this.formBuilder.group(formGroupConfig);

        this.stateService.values([States.user, States.themeConfig]).subscribe((value) => {
            if(!value.themeConfig){
                return false;
            }
            if(!value.user){
                this.router.navigateByUrl('/Login');
                return true;
            }
            this.mustAcceptTermsOfUse = value.user.mustAcceptTermsOfUse && !value.themeConfig.dontShowTermsOfUse;
            if (this.mustAcceptTermsOfUse) {
                this.changePasswordForm.addControl('acceptTermsOfUse',  new FormControl('', Validators.requiredTrue));
            }

            if (value.user && value.user.mustChangePassword === false) {
                this.router.navigateByUrl('/Home');
            }

            return true;
        }, true).while.falsy();
    }

    public changePasswordForm: FormGroup;

    public changePasswordError: string;

    public changePasswordButtonState: string;

    public mailIsSended: boolean = false;

    public mustAcceptTermsOfUse: boolean = false;

    public async changePassword() {
        this.changePasswordError = null;
        this.formHelper.markFormGroupTouched(this.changePasswordForm);
        const oldpassword = this.changePasswordForm.controls.oldpassword.value;
        const password = this.changePasswordForm.controls.password.value;
        const confirmPassword = this.changePasswordForm.controls.confirmPassword.value;
        const idParameter = this.routingInfos.getCurrentRoutingParams();
        if (password !== confirmPassword) {
            this.changePasswordError = __i18n(
                'Password and password confirmation must be equal!',
                'landingpage.changepassword.error.text.equal'
            );
        } else {
            if (this.changePasswordForm.valid) {
                try {
                    await this.user.changePassword({
                        requestId: idParameter.id,
                        oldpassword,
                        newPassword: password,
                        confirmPassword
                    });

                    //add message and navigate to login
                    this.messageService.addMessage({
                        type: MessageType.success,
                        text: __i18n('The password has been changed', 'landingpage.info.text.passwordchanged'),
                        target: 'landingpage'
                    });

                    this.messageService.addMessage({
                        type: MessageType.success,
                        text: __i18n('The password has been changed', 'landingpage.info.text.passwordchanged')
                    });
                    this.eventBus.trigger(ActionEvents.loadUser);
                } catch (e) {
                    console.error('Passwort Change Error! [ChangePasswordComponent.changePassword]', e);
                    this.changePasswordError =
                        this.httpHelper.getErrorMessage(e) ||
                    __i18n('The password could not be changed, an error occurred.', 'landingpage.changepassword.error');
                }
            }
        }
    }
}
